module.exports = __webpack_public_path__ + "static/media/call-grey-icon.dde8dddb.svg";